import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import 'moment/locale/zh-cn';
import './index.less';
import asyncComponent from './components/async-component';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

const placeholder = <span style={{ position: 'fixed', width: '100%', height: '100%', display: 'flex', alignItems: 'center', 'justifyContent': 'center' }}>loading……</span>


const PageLogin = asyncComponent(() => import('./pages/login'), placeholder);
const PageHome = asyncComponent(() => import('./pages/home'), placeholder);

const PageAdmin = asyncComponent(() => import('./pages/admin'), placeholder);
const PageSystemLogs = asyncComponent(() => import('./pages/systemLogs'), placeholder);
const PagePermission = asyncComponent(() => import('./pages/permission'), placeholder);
const PageRole = asyncComponent(() => import('./pages/role'), placeholder);
const PageCompany = asyncComponent(() => import('./pages/company'), placeholder);
const PageBizType = asyncComponent(() => import('./pages/biztype'), placeholder);
const PageSupplier = asyncComponent(() => import('./pages/supplier'), placeholder);
const PageFinancerecord = asyncComponent(() => import('./pages/financerecord'), placeholder);
moment.locale('zh-cn');


const App = () => (
  <ConfigProvider locale={zhCN}>
    <Router>
      <Switch>
        <Route exact path="/"><PageHome /></Route>
        <Route exact path="/financerecord/list"><PageFinancerecord /></Route>
        <Route exact path="/login"><PageLogin /></Route>
        <Route exact path="/admin/list"><PageAdmin /></Route>
        <Route exact path="/logs/list"><PageSystemLogs /></Route>
        <Route exact path="/permission/list"><PagePermission /></Route>
        <Route exact path="/role/list"><PageRole /></Route>
        <Route exact path="/company/list"><PageCompany /></Route>
        <Route exact path="/biztype/list"><PageBizType /></Route>
        <Route exact path="/supplier/list"><PageSupplier /></Route>
        <Route render={() => (<Redirect to="/result/404" />)} />
      </Switch>
    </Router>
  </ConfigProvider>
 
);

ReactDOM.render(<App />, document.getElementById('root'));
